"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PxError = exports.MfaRequiredError = exports.ApwError = exports.GqlError = exports.getError = void 0;
const globalTypes_1 = require("../__generated__/globalTypes");
function getError(e) {
    var _a;
    const errors = (_a = e === null || e === void 0 ? void 0 : e.response) === null || _a === void 0 ? void 0 : _a.errors;
    if (isPxError(e.response)) {
        return new PxError(e);
    }
    if (!errors) {
        e.criticalError = true;
        return e;
    }
    const error = errors[0];
    error.apiName = e.apiName;
    if (isApwError(error)) {
        if (error.extensions.apw_error.error == globalTypes_1.ErrorCodes.mfa_required) {
            return new MfaRequiredError(error);
        }
        return new ApwError(error);
    }
    return new GqlError(error);
}
exports.getError = getError;
class GqlError extends Error {
    constructor(e) {
        super(e.message);
        this.extensions = e.extensions;
        this.code = this.extensions.code;
        this.apiName = e.apiName;
        this.criticalError = !!this.extensions.shouldRetry;
    }
}
exports.GqlError = GqlError;
class ApwError extends GqlError {
    constructor(error) {
        super(error);
        this.code = error.extensions.apw_error.error;
        this.description = error.extensions.apw_error.error_description;
        this.criticalError = !!this.extensions.shouldRetry;
        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
        this.payload = error.extensions.apw_error;
    }
}
exports.ApwError = ApwError;
class MfaRequiredError extends ApwError {
    constructor(error) {
        super(error);
        this.mfaPayload = {
            email: error.extensions.apw_error.email,
            uuid: error.extensions.apw_error.uuid,
            mfa_token: error.extensions.apw_error.mfa_token,
        };
    }
}
exports.MfaRequiredError = MfaRequiredError;
class PxError extends Error {
    constructor(e) {
        super('px_error');
        const res = e.response;
        this.appId = res.appId;
        this.jsClientSrc = res.jsClientSrc;
        this.firstPartyEnabled = res.firstPartyEnabled;
        this.uuid = res.uuid;
        this.hostUrl = res.hostUrl;
        this.blockScript = res.blockScript;
        this.apiName = e.apiName;
        this.criticalError = false;
    }
}
exports.PxError = PxError;
function isApwError(e) {
    return 'apw_error' in e.extensions;
}
function isPxError(res) {
    return res && res.appId && res.jsClientSrc;
}
